import { FC } from "react";

import { TabsBottomInfoItemStyled } from "../../../../../right";
import { useRideBoardingSegmentDurationLabel } from "./hooks/use-ride-boarding-segment-duration-label";
import { RideBoardingSegmentDurationLabel } from "./ride-boarding-segment-duration-label";

export const RideBoardingSegmentDurationHeaderItem: FC = () => {
  const { isVisible } = useRideBoardingSegmentDurationLabel();

  if (!isVisible) {
    return null;
  }

  return (
    <TabsBottomInfoItemStyled>
      <RideBoardingSegmentDurationLabel />
    </TabsBottomInfoItemStyled>
  );
};
